import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import StoreButtons from './StoreButtons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* About Section */}
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/images/ow-client-logo.png" alt="OW Logo" />
                <h3>OW Client</h3>
              </div>
              <p className="footer-description">
                Transform your dining experience with our innovative restaurant
                ordering and payment app. Order smarter, dine better.
              </p>
              <StoreButtons />
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><a href="/#how-it-works">Client App - How It Works</a></li>
                <li><Link to="/ow-owner">Restaurant App - How It Works</Link></li>
                <li><Link to="/guide">Restaurant App - Guide</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/privacy-policy-owner">Privacy Policy (Owner)</Link></li>
                <li>
                  <a
                    href="https://facebook.com/owclient"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="facebook-link"
                  >
                    <svg className="facebook-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                    Follow us on Facebook
                  </a>
                </li>
              </ul>
            </div>

            {/* Connect With Us - Commented out for future social media integration
            <div className="footer-section">
              <h4>Connect With Us</h4>
              <p className="footer-social-text">
                Stay updated with our latest features and news
              </p>
              <div className="social-links">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="social-link"
                >
                  📘
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                  className="social-link"
                >
                  🐦
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="social-link"
                >
                  📷
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="social-link"
                >
                  💼
                </a>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} OW Client Services. All rights reserved.
            </p>
            <div className="footer-owner">
              <Link to="/ow-owner" className="owner-link">
                Powered by OW Owner
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

